'use client';

interface ProgressCardProps {
  title: string;
  total?: number;
  percentage: number | null;
  points: string;
  color?: string;
}

export function ProgressCard({
  title,
  total,
  percentage,
  points,
  color = '#7C3AED',
}: ProgressCardProps) {
  const safePercentage = Number.isFinite(percentage) ? (percentage as number) : 0;

  return (
    <div className='bg-white p-2 rounded-lg shadow-sm border border-gray-100 flex flex-col items-center'>
      <div className='md:text-base text-sm text-gray-600'>{title}</div>
      {total ? (
        <div className='md:text-lg text-base text-gray-900 font-semibold'>{total}</div>
      ) : null}
      <div className='relative w-24 h-24 flex items-center justify-center'>
        <svg className='w-full h-full transform -rotate-90'>
          <circle cx='48' cy='48' r='40' stroke='#E5E7EB' strokeWidth='8' fill='transparent' />
          <circle
            cx='48'
            cy='48'
            r='40'
            stroke={color}
            strokeWidth='8'
            fill='transparent'
            strokeDasharray={251.2}
            strokeDashoffset={251.2 - (251.2 * safePercentage) / 100}
            strokeLinecap='round'
          />
        </svg>
        <div className='absolute md:text-lg text-sm text-gray-800'>{`${safePercentage}%`}</div>
      </div>
      <div className='md:text-2xl text-base text-brand-800 font-semibold'>{points}</div>
    </div>
  );
}
